<template>
    <div class="main-layout-section admin-portal secondary">
        <AdminHeader 
        @setPodData="setPodData($event)" />
        
        <div class="w-logo mb-3">
            <img :src="logo_file" alt="logo" class="w-input-fields animate__animated animate__fadeIn animate__fast" v-if="logo_file !== '' && logo_file !== null"/>
        </div>

        <div class="main-content">
            <h3 class="page-subheading mb-3 animate__animated animate__fadeIn animate__fast">Create New Reservation</h3>

            <div class="col-md-11 mx-auto">

                <div class="admin-general-section">
                    <div class="admin-general-section-buttons">
                        <router-link :to="`/admin/reservations`" class="admin-general-section-button">
                            Back To Reservations Management
                        </router-link>
                    </div>
                </div>

                <div class="row m-0 p-0 col-md-12 col-sm-12 m-auto">
                    <!-- start of pod form -->
                    <b-form inline @submit.stop.prevent class="m-0 p-0">

                        <div
                        class="
                        w-form-control
                        animate__animated animate__fadeIn animate__fast m-0 p-0
                        " 
                        v-if="lab_reservation_status == 0"
                        >
                            <p class="text-default mt-3 mb-0">This lab has no associated reservation email address. You must return to the Lab Edit page and enter one there before continuing.</p>
                        </div>

                        <div class="row">
                            <div class="d-flex mb-1 col-md-12 flex-column">
                                <label for="" class="form-main-label animate__animated animate__fadeIn animate__fast w-100">Group Name</label>
                                <div class="w-form-control w-input-fields animate__animated animate__fadeIn animate__fast w-100" :class="{ 'is_invalid': $v.form.group_name.$error }">
                                    <span><i class="fa-solid fa-file"></i></span>
                                    <b-form-input
                                        v-model="form.group_name"
                                        id="rss-url"
                                        class="mb-2 mr-sm-2 mb-sm-0 user-name bg-lightBlack border-0 h-53"
                                        :class="{ 'is-invalid': $v.form.group_name.$error }"
                                        placeholder="Enter group name"
                                    ></b-form-input>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="d-flex mb-1 col-md-12 flex-column">
                                <label for="" class="form-main-label animate__animated animate__fadeIn animate__fast w-100">Select Lab</label>
                                <div class="w-form-control w-input-fields animate__animated animate__fadeIn animate__fast w-100" :class="{ 'is_invalid': $v.form.lab_id.$error }">
                                    <span><i class="fa-solid fa-file"></i></span>
                                    <b-form-select
                                        v-model="form.lab_id"
                                        :options="labs"
                                        text-field="value"
                                        value-field="id"
                                        id="lab_id"
                                        class="" 
                                        @change="podsByLab"
                                        :class="[ $v.form.lab_id.$error ? 'is-invalid' : '', form.lab_id == '' ? 'text-grey' : '' ]"
                                        placeholder="Select a lab"
                                    ></b-form-select>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="d-flex mb-1 col-md-12 flex-column">
                                <label for="" class="form-main-label animate__animated animate__fadeIn animate__fast w-100">Select Pods</label>
                                <div class="pods-list-container animate__animated animate__fadeIn animate__fast w-100" :class="{ 'is_invalid': $v.form.pods_list.$error }">
                                    <div v-if="pods.length > 0" class="w-100">
                                        <span>Select All</span>
                                        <label class="gen-switch tickcross">
                                            <input type="checkbox" 
                                            ref="select_all_pods" 
                                            @change="handleSelectPods('all')"
                                            >
                                            <span class="gen-switch-slider gen-switch-round tickcross"></span>
                                        </label>
                                    </div>

                                    <div v-for="pod in pods" :key="pod.id">
                                        <span>{{pod.license}}</span>
                                        <label class="gen-switch tickcross">
                                            <input type="checkbox" 
                                            :ref="pod.pod_id_key+'_select_pod'" 
                                            :class="pod.id+'-pod-id'"
                                            :checked="selected_pods.indexOf(pod.pod_id_key) !== -1" 
                                            @change="handleSelectPods('', pod.pod_id_key, pod.pod_id_key+'_select_pod')"
                                            >
                                            <span class="gen-switch-slider gen-switch-round tickcross"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>
                        
                        <div class="row">
                            <!-- <div class="d-flex mb-1 col-md-4 flex-column">
                                <label for="" class="form-main-label animate__animated animate__fadeIn animate__fast w-100">Date</label>
                                <div class="w-form-control w-input-fields animate__animated animate__fadeIn animate__fast w-100" :class="{ 'is_invalid': $v.form.start_date.$error }">
                                    <span><i class="fa-solid fa-file"></i></span>
                                    <input
                                        type="text"
                                        value=""
                                        placeholder="MM/DD/YYYY"
                                        v-model="form.start_date" 
                                        v-mask="date_mask"
                                    />
                                </div>
                            </div> -->
                            <div class="d-flex mb-1 col-md-6 flex-column">
                                <label for="" class="form-main-label animate__animated animate__fadeIn animate__fast w-100">Start Time</label>
                                <!-- <b-form-timepicker :reset-button="true" :no-flip="true" v-model="form.start_time" dropup class="overflow-visible timepicker-schedule w-form-control w-input-fields animate__animated animate__fadeInUp animate__delay-2s w-100" :class="{ 'is_invalid': $v.form.start_time.$error }"></b-form-timepicker> -->
                                <b-input-group class="timepicker-schedule animate__animated animate__fadeIn animate__fast">
                                    <b-input-group-append>
                                        <b-form-timepicker
                                        button-only 
                                        dropup 
                                        left 
                                        @context="startContext"
                                        ></b-form-timepicker>
                                    </b-input-group-append>
                                    <b-form-input
                                        v-model="form.start_time"
                                        type="text"
                                        placeholder="HH:mm AM/PM" 
                                        class="w-form-control w-input-fields mb-0" 
                                        :class="{ 'is_invalid': $v.form.start_time.$error }" 
                                        v-mask="'?##:## AA'"
                                    ></b-form-input>
                                </b-input-group>
                            </div>

                            <!-- <div class="d-flex mb-1 col-md-4 flex-column">
                                <label for="" class="form-main-label animate__animated animate__fadeIn animate__fast w-100">End Date</label>
                                <div class="w-form-control w-input-fields animate__animated animate__fadeIn animate__fast w-100" :class="{ 'is_invalid': $v.form.end_date.$error }">
                                    <span><i class="fa-solid fa-file"></i></span>
                                    <input
                                        type="text"
                                        value=""
                                        placeholder="MM/DD/YYYY"
                                        v-model="form.end_date" 
                                        v-mask="date_mask"
                                    />
                                </div>
                            </div> -->
                            <div class="d-flex mb-1 col-md-6 flex-column">
                                <label for="" class="form-main-label animate__animated animate__fadeIn animate__fast w-100">End Time</label>
                                <!-- <b-form-timepicker :reset-button="true" :no-flip="true" v-model="form.end_time" dropup class="overflow-visible timepicker-schedule w-form-control w-input-fields animate__animated animate__fadeInUp animate__delay-2s w-100" :class="{ 'is_invalid': $v.form.end_time.$error }"></b-form-timepicker> -->
                                <b-input-group class="timepicker-schedule animate__animated animate__fadeIn animate__fast">
                                    <b-input-group-append>
                                        <b-form-timepicker
                                        button-only 
                                        dropup 
                                        left 
                                        @context="endContext"
                                        ></b-form-timepicker>
                                    </b-input-group-append>
                                    <b-form-input
                                        v-model="form.end_time"
                                        type="text"
                                        placeholder="HH:mm AM/PM" 
                                        class="w-form-control w-input-fields mb-0" 
                                        :class="{ 'is_invalid': $v.form.end_time.$error }" 
                                        v-mask="'?##:## AA'"
                                    ></b-form-input>
                                </b-input-group>
                            </div>

                        </div>

                        <div class="col-md-12 mx-auto calendar-wrapper mb-4 mt-2">
                            <FullCalendar 
                                ref="fullCalendar"
                                :options="calendarOptions"
                            />
                        </div>

                        <div class="row">
                            <div class="d-flex mb-1 col-md-12 flex-column">
                                <label for="" class="form-main-label animate__animated animate__fadeIn animate__fast w-100">List of Authorized User Accounts</label>
                                <div class="w-form-control w-input-fields animate__animated animate__fadeIn animate__fast w-100" :class="{ 'is_invalid': $v.form.emails_list.$error }">
                                    <b-form-textarea
                                        v-model="form.emails_list"
                                        id="note"
                                        class="mb-2 mr-sm-2 mb-sm-0 user-name bg-lightBlack border-0 w-textarea"
                                        :class="{ 'is-invalid': $v.form.emails_list.$error }"
                                        placeholder="Emails List"
                                        no-resize
                                    ></b-form-textarea>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="d-flex mb-1 col-md-12 flex-column">
                                <label for="" class="form-main-label animate__animated animate__fadeIn animate__fast w-100">Price</label>
                                <div class="w-form-control w-input-fields animate__animated animate__fadeIn animate__fast w-100" :class="{ 'is_invalid': $v.form.price.$error }">
                                    <span><i class="fa-solid fa-file"></i></span>
                                    <b-form-input
                                        v-model="form.price"
                                        id="price"
                                        class="mb-2 mr-sm-2 mb-sm-0 user-name bg-lightBlack border-0 h-53"
                                        :class="{ 'is-invalid': $v.form.price.$error }"
                                        placeholder="Enter price"
                                    ></b-form-input>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="d-flex mb-1 col-md-12 flex-column">
                                <label for="" class="form-main-label animate__animated animate__fadeIn animate__fast w-100">Notes</label>
                                <div class="w-form-control w-input-fields animate__animated animate__fadeIn animate__fast w-100" :class="{ 'is_invalid': $v.form.notes.$error }">
                                    <b-form-textarea
                                        v-model="form.notes"
                                        id="notes"
                                        class="mb-2 mr-sm-2 mb-sm-0 user-name bg-lightBlack border-0 w-textarea"
                                        :class="{ 'is-invalid': $v.form.notes.$error }"
                                        placeholder="Notes"
                                        no-resize
                                    ></b-form-textarea>
                                </div>
                            </div>
                        </div>

                        <div
                        class="
                        w-form-control
                        animate__animated animate__fadeIn animate__fast m-0 p-0
                        " 
                        v-if="lab_reservation_status == -1 || lab_reservation_status == 1"
                        >
                            <a
                            href="javascript:void(0)"
                            @click="handleReservationReq"
                            class="flex-fill"
                            >Save</a
                            >
                        </div>
                    </b-form>
                    <!-- end of pod form -->
                </div>

            </div>

        </div>

        <!-- start of footer section -->
        <div class="col-md-12 mx-auto">
            <AdminFooter type="inner" />
        </div>
        <!-- end of footer section -->
        
    </div>
</template>

<script>
import AdminHeader from "@/views/admin/AdminHeader.vue";
import { adminSaveReservation, adminGetLabsList, adminGetPodsList, adminGetReservationsListForCalendar } from "../../services/AdminService";
import Vue from 'vue'
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
import { required } from 'vuelidate/lib/validators';
import AdminFooter from "@/views/admin/AdminFooter.vue";
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

export default {
    name: "AdminNewReservation-view",
    components: { AdminHeader, AdminFooter, FullCalendar },
    data() {
        return {
            labs: [],
            pods: [],
            selected_pods: [],
            form: {
                client_id : '',
                lab_id : '',
                start_date : '',
                start_time : '',
                end_date : '',
                end_time : '',
                pods_list : '',
                emails_list : '',
                group_name : '',
                price: 0,
                notes: ''
            },
            date_mask: '##/##/##?#?#',
            lab_reservation_status: -1,

            selectedDate: "",
            events: [],
            currentMonthEvents: [],
            calendarOptions: {
                plugins: [dayGridPlugin, interactionPlugin],
                initialView: 'dayGridMonth',   // IMPORTANT (must NOT be empty)
                selectable: true,
                selectMirror: true,
                unselectAuto: true,
                // select: this.handleRangeSelect,
                dateClick: this.handleDateClick,
                events: [],
                datesSet: this.handleDatesSet,
                dayMaxEvents: 4,
                dayMaxEventRows: true,
                expandRows: false,
                moreLinkClick: 'popover',
                eventDisplay: 'block',
                eventDidMount(info) {
                    info.el.setAttribute(
                        'title',
                        info.event.title
                    )
                },
                eventContent: function(arg) {
                    // Use default rendering for all-day events
                    if (arg.event.allDay) {
                        return true;
                    }

                    let start = arg.event.start;
                    let end = arg.event.end;
                    let startTime = start
                    ? start.toLocaleTimeString([], {
                        hour: '2-digit',
                        minute: '2-digit'
                    })
                    : '';

                    let endTime = end
                    ? end.toLocaleTimeString([], {
                        hour: '2-digit',
                        minute: '2-digit'
                    })
                    : '';
                    return {
                        html: `
                        <div class="fc-event-title-custom">
                            <div class="fc-event-title-line">
                                ${arg.event.title}
                            </div>

                            <div class="fc-event-time-line">
                                ${startTime} - ${endTime}
                            </div>
                        </div>`
                    };
                }
            },
            calendar_api_state: false,
            calender_api_request: null,
            currentCalendarRange: {
                start: null,
                end: null
            }
        };
    },

    validations: {
        form : {
            lab_id : {required},
            start_date : {required},
            start_time : {required},
            end_date : {required:false},
            end_time : {required},
            pods_list : {required},
            emails_list : {required:false},
            group_name: {required},
            price: {required:false},
            notes: {required:false}
        }
    },

    computed: {
        logo_file() {
            return this.$store.getters.getThemeLogo().logo;
        }
    },

    watch: {
        'form.lab_id'() {
            this.fetchEventsList();
        },
        selected_pods: {
            handler() {
                this.fetchEventsList();
            },
            deep: true
        }
    },

    methods: {
        labsList() {
            let user_data = JSON.parse(localStorage.user_sess_data);
            let params = {
                token: user_data.token,
                client_id: user_data.client_id
            };
            adminGetLabsList(params).then(response => {
                this.labs = response.data.labs;
                // add empty option as placeholder
                this.labs.splice(0, 0, {'id' : '', 'value' : 'Select a lab'});
            });
        },

        podsByLab() {
            let user_data = JSON.parse(localStorage.user_sess_data);
            let params = {
                token: user_data.token,
                client_id: user_data.client_id,
                lab_id: this.form.lab_id
            };
            adminGetPodsList(params).then(response => {
                this.pods = response.data.pods;
                this.lab_reservation_status = response.data.lab_reservation_exist;
            });
        },

        handleSelectPods(type="", pod_id, ref_id) {
            let _self = this;
            if(type == "all") {
                this.selected_pods = [];
                if(this.$refs.select_all_pods.checked) {
                    this.pods.forEach((item) => {
                        _self.selected_pods.push(item.pod_id_key);
                    });
                }
            }
            else {
                if(this.$refs[ref_id][0].checked) {
                    this.selected_pods.push(pod_id);
                }
                else {
                    this.selected_pods.splice(this.selected_pods.indexOf(pod_id), 1);
                }
                if(this.pods.length == this.selected_pods.length) {
                    this.$refs.select_all_pods.checked = true;
                }
                else {
                    this.$refs.select_all_pods.checked = false;
                }
            }
            if(this.selected_pods.length > 0) {
                this.form.pods_list = this.selected_pods.join(',');
            }
            else {
                this.form.pods_list = '';
            }
        },

        handleReservationReq() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.makeToast("error", "generic-required-message");
            } 
            else {
                this.syncFormSchedules();
                let user_data = JSON.parse(localStorage.user_sess_data);
                let data = this.form;
                console.log("DATA IS : ", data);
                data.token = user_data.token;
                data.client_id = user_data.client_id;
                const [year, month, day] = data.start_date.split('-');
                data.start_date = `${month}/${day}/${year}`;
                data.start_datetime = data.start_date + " " + data.start_time;
                // data.end_datetime = data.end_date + " " + data.end_time;
                data.end_datetime = data.start_date + " " + data.end_time;

                adminSaveReservation(data).then(response => {
                    if(response.status){
                        this.makeToast("success", response.message);
                        this.selected_pods = [];
                        this.resetForm();
                        this.$v.$reset();
                        setTimeout(() => {
                            this.$router.push({ name: "Admin Edit Reservation", params: {'reservation_id': response.data.reservation_id }});
                        }, 3000);
                    } else {
                        this.makeToast("error", response.message);
                    }
                }); 
            }
        },

        resetForm() {
            var self = this;
            //Iterate through each object field, key is name of the object field`
            Object.keys(this.form).forEach(function(key) {
                self.form[key] = '';
            });
        },

        makeToast(variant = "default", message) {
            this.$root.$emit("toast_message", {'type' : variant, 'message' : message});
        },

        setPodData(obj) {
            this[obj.key] = obj.value;
        },

        startContext(ctx) {
            if(ctx.minutes >= 0) {
                let ts = ctx.formatted.split(" ");
                if(ts.length > 1 && ts[0].includes(':')) {
                    let ts1 = ts[0].split(":");
                    let ts_final = (ts1[0] < 10 ? '0'+ts1[0] : ts1[0]) + ":" + ts1[1] + " " + ts[1];
                    this.form.start_time = ts_final;
                }
            }
        },
        endContext(ctx) {
            if(ctx.minutes >= 0) {
                let ts = ctx.formatted.split(" ");
                if(ts.length > 1 && ts[0].includes(':')) {
                    let ts1 = ts[0].split(":");
                    let ts_final = (ts1[0] < 10 ? '0'+ts1[0] : ts1[0]) + ":" + ts1[1] + " " + ts[1];
                    this.form.end_time = ts_final;
                }
            }
        },

        // fullcalendar functions
        handleDateClick(info) {
            console.log("I AM HERE : ", info);
            // const dateStr = this.formatDateLocal(new Date(info.dateStr));
            const dateStr = info.dateStr;
            if (this.selectedDate == dateStr) {
                this.selectedDate = "";
            } else {
                this.selectedDate = dateStr;
            }
            this.syncEvents();
        },
        syncEvents() {
            // fetch selected dates
            const temporary_events = [{
                id: `temp_${this.selectedDate}`,
                start: this.selectedDate,
                allDay: true,
                display: 'background',
                classNames: ['selected-date']
            }];
            const db_events = this.currentMonthEvents || [];
            console.log("DB EVENTS ARE : ", db_events);

            this.calendarOptions = {
                ...this.calendarOptions,

                events: [
                    ...db_events,
                    ...temporary_events
                ]
            }

            // sync schedules
            this.syncFormSchedules();
        },
        syncFormSchedules() {
            if(this.selectedDate == "") {
                this.form.start_date = "";
                return;
            }
            if(this.form.start_time == '' || this.form.end_time == '') {
                return;
            }

            // fetch selected dates
            this.form.start_date = this.selectedDate;
        },
        formatDateLocal(date) {
            const y = date.getFullYear()
            const m = String(date.getMonth() + 1).padStart(2, '0')
            const d = String(date.getDate()).padStart(2, '0')
            return `${y}-${m}-${d}`
        },
        datesSet(info) {
            this.currentCalendarRange = {
                start: info.startStr,
                end: info.endStr
            }
            this.fetchEventsList();
        },
        handleDatesSet(info) {
            this.currentCalendarRange = {
                start: info.startStr,
                end: info.endStr
            }
            this.fetchEventsList();
        },
        async fetchEventsList() {
            if(this.form.lab_id == '' || !this.currentCalendarRange.start) {
                return;
            }
            if(this.calender_api_request) {
                this.calender_api_request.abort();
                this.calender_api_request = null;
            }
            let user_data = JSON.parse(localStorage.user_sess_data);
            let params = {
                token: user_data.token,
                client_id: user_data.client_id,
                lab_id: this.form.lab_id,
                pods: this.selected_pods,
                start: this.currentCalendarRange.start,
                end: this.currentCalendarRange.end,
                res_type: 'single'
            };

            this.calender_api_request = new AbortController();
            this.calendar_api_state = true;
            const response = await adminGetReservationsListForCalendar(
                params,
                this.calender_api_request.signal
            );
            this.calendar_api_state = false;
            this.currentMonthEvents = response.data.reservations;
            this.syncEvents();
        },
  },

  mounted() {
    this.labsList();
  }

};
</script>
<style scoped>
.pods-list-container {
    display: flex;
    flex-direction: row;
    padding: 10px 10px;
    column-gap: 20px;
    background: #d8d8d8;
    margin: 10px 0px;
    border-radius: 8px;
    min-height: 56px;
    flex-wrap: wrap;
    row-gap: 15px;
}
.pods-list-container > div {
    display: flex;
    flex-direction: row;
    width: fit-content;
    color: #191919;
    font-weight: 700;
    align-items: center;
    column-gap: 10px;
}
/* start of general switches */
.gen-switch {
    position: relative;
    display: inline-block;
    width: 70px;
    height: 34px;
}
.gen-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}
.gen-switch-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #7f7f7f;
    -webkit-transition: .4s;
    transition: .4s;
}  
.gen-switch-slider:before {
    position: absolute;
    content: "";
    height: 40px;
    width: 40px;
    left: 0px;
    bottom: -2px;
    -webkit-transition: .4s;
    transition: .4s;
    background-color: var(--client-hover);
    font-family: "FontAwesome";
    display: flex;
    align-items: center;
    justify-content: center;;
    color: #d8d8d8;
}
.gen-switch input:checked + .gen-switch-slider:before {
    -webkit-transform: translateX(31px);
    -ms-transform: translateX(31px);
    transform: translateX(31px);
    background-color: var(--client-primary);
}
.gen-switch-slider.gen-switch-round {
    border-radius: 34px;
}
.gen-switch-slider.gen-switch-round:before {
    border-radius: 50%;
}
.gen-switch-slider.lockunlock:before {
    content: "\f023";
}
.gen-switch.lockunlock input:checked + .gen-switch-slider.lockunlock:before {
    content: "\f13e";
}
.gen-switch-slider.tickcross:before {
    content: "\f00d";
}
.gen-switch.tickcross input:checked + .gen-switch-slider.tickcross:before {
    content: "\f00c";
}
.gen-switch-slider.playpause:before {
    content: "\f04c";
}
.gen-switch.playpause input:checked + .gen-switch-slider.playpause:before {
    content: "\f04b";
}
/* end of general switches */

/* start of calendar styles */
:deep(.fc-toolbar) {
  color: #d8d8d8;
  font-family: sans-serif;
}
:deep(.fc .fc-toolbar-title) {
    font-size: 1.50em;
    margin: 0px;
    font-family: sans-serif;
    font-weight: 600;
}
:deep(.fc .fc-today-button) {
    text-transform: capitalize;
    font-family: sans-serif;
    background-color: transparent;
    border: 2px solid #7f7f7f;
}
:deep(.fc .fc-today-button:hover) {
    background-color: var(--client-primary);
    border: 2px solid var(--client-primary);
}
:deep(.fc .fc-prev-button),
:deep(.fc .fc-next-button) {
    background-color: transparent;
    border: 2px solid #7f7f7f;
    color: #d8d8d8;
}
:deep(.fc .fc-prev-button) {
    border-right: 0;
}
:deep(.fc .fc-prev-button:hover),
:deep(.fc .fc-next-button:hover) {
    background-color: var(--client-primary);
    border-color: var(--client-primary);
}
:deep(.fc-col-header) {
    background-color: #7f7f7f;
}
:deep(.fc-col-header .fc-col-header-cell) {
    padding: 0.5em;
}
:deep(.fc-col-header .fc-col-header-cell a) {
    color: #191919;
    text-decoration: none;
}
:deep(.fc-daygrid-body .fc-daygrid-day a) {
    color: #d8d8d8;
    text-decoration: none;
    font-weight: 600;
}
:deep(.fc-theme-standard .fc-scrollgrid) {
    border-color: #d8d8d8;
}
:deep(.fc-theme-standard td), 
:deep(.fc-theme-standard th) {
    border-color: #d8d8d8;
}
:deep(.fc .fc-daygrid-day.fc-day-today) {
    background-color: #19191970;
    opacity: 1;
}
:deep(.fc .fc-daygrid-day.fc-day-today a) {
    color: #d8d8d8;
}
:deep(.fc .fc-daygrid-day .selected-date) {
    background-color: var(--client-primary);
    color: #d8d8d8;
    opacity: 1;
}
:deep(.fc-daygrid-event) {
  border-radius: 6px;
  padding: 2px 6px;
}
:deep(.fc-event-title) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #d8d8d8;
}
:deep(.fc-event-title-custom) {
  overflow: hidden;
  width: 100%;
}
:deep(.fc-event-title-line) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #d8d8d8;
  font-weight: 600;
  font-size: 12px;
  display: block;
}
:deep(.fc-event-time-line) {
  font-size: 11px;
  white-space: nowrap;
}
:deep(.fc-h-event) {
    background-color: transparent;
    border: 1px solid var(--client-primary);
    display: block;
}
:deep(.fc-h-event .fc-event-time) {
    overflow: visible;
}
:deep(.fc-theme-standard .fc-popover) {
    background: #d8d8d8;
    border-color: var(--client-primary);
}
:deep(.fc-theme-standard .fc-popover-header) {
    background: var(--client-primary);
    color: #fff;
}
:deep(.fc-popover-body .fc-h-event) {
    background: var(--client-primary);
}
:deep(.current-reservation-event) {
    background: #3f3f3f;
}
/* end of calendar widget styles  */
</style>